export const formatDate = (value) => {
    if (value) {
        value = value.toString()
        return `${value.substring(3, 5)}/${value.substring(5)}/${value.substring(1, 3)}`
    }
    return ''
}